import { render, staticRenderFns } from "./PromoToProduct.vue?vue&type=template&id=222a61a0&scoped=true"
import script from "./PromoToProduct.vue?vue&type=script&lang=js"
export * from "./PromoToProduct.vue?vue&type=script&lang=js"
import style0 from "./PromoToProduct.vue?vue&type=style&index=0&id=222a61a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a61a0",
  null
  
)

export default component.exports